import { render, staticRenderFns } from "./dataTable.vue?vue&type=template&id=7a72532b&scoped=true"
import script from "./dataTable.vue?vue&type=script&lang=js"
export * from "./dataTable.vue?vue&type=script&lang=js"
import style0 from "./dataTable.vue?vue&type=style&index=0&id=7a72532b&prod&lang=scss&scoped=true"
import style1 from "./dataTable.vue?vue&type=style&index=1&id=7a72532b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a72532b",
  null
  
)

export default component.exports